import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';
import { BottomNav } from '@/components/BottomNav';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const loadUnreadCount = useCallback(async () => {
    if (!user?.id) return;

    const { data } = await supabase
      .from('messages')
      .select('id')
      .eq('is_read', false)
      .neq('sender_id', user.id);

    setUnreadCount(data?.length || 0);
  }, [user?.id]);

  useEffect(() => {
    if (!user) return;

    loadUnreadCount();
    const channel = supabase
      .channel('unread-messages')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages',
        },
        () => loadUnreadCount()
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user, loadUnreadCount]);

  return (
    <div className="min-h-screen bg-[#05070a] text-foreground">
      <div className="relative mx-auto min-h-screen w-full max-w-[390px] overflow-x-hidden border-x border-white/10 bg-[#080a0f] shadow-2xl shadow-black/50">
        <main className="min-h-screen pb-24">{children}</main>
        <BottomNav unreadCount={unreadCount} />
      </div>
    </div>
  );
}
